/*
 * Purabelle duft-quiz. Almindelig JavaScript uden byggetrin.
 *
 * Taler med backenden via Shopifys app proxy på /apps/quiz. Svarene gemmes i
 * localStorage, så en genindlæsning midt i quizzen fortsætter samme sted, og
 * resultatet kan genbesøges via ?session=<id>.
 */
(function () {
  'use strict';

  const API_BASE = '/apps/quiz';
  const STORAGE_KEY = 'purabelle-quiz';
  const REQUEST_TIMEOUT_MS = 10000;
  const MIN_LOADING_MS = 1000;
  const ADVANCE_DELAY_MS = 200;
  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  /** Danske standardtekster. Temaets locale-filer (purabelle_quiz.*) overskriver dem pr. sprog. */
  const DEFAULT_TEXT = {
    eyebrow: "Duft-quiz",
    nojs_text: "Quizzen kræver JavaScript. Slå JavaScript til i din browser, eller",
    nojs_link: "se alle vores dufte",
    back: "Tilbage",
    next: "Videre",
    skip: "Spring over",
    progress: "{n} af {total}",
    choose_up_to: "Vælg op til {max}",
    loading: "Vi finder dine dufte …",
    result_eyebrow: "Dit resultat",
    result_title_many: "Dine {count} matches",
    result_title_one: "Dit match",
    result_title_none: "Vi fandt ingen dufte, der matcher lige nu",
    result_lead: "Vi har fundet de dufte, der passer bedst til dine svar.",
    size_legend: "Størrelse",
    best_match: "Dit bedste match",
    match_pct: "{pct} % match",
    notes: "Noter: {notes}",
    add_to_cart: "Læg i kurv",
    added: "Lagt i kurv ✓",
    sold_out: "Udsolgt",
    sold_out_in: "Udsolgt i {size}",
    card_price: "{size} · {price}",
    bundle_title: "Få alle {count} som pakke",
    bundle_items_label: "Dufte i pakken",
    bundle_missing: "Pakken er med de {count}, der er på lager i {size}.",
    bundle_add_all: "Læg alle {count} i kurven",
    bundle_add_some: "Læg de {count} i kurven",
    bundle_add_save: "{what} – spar {amount}",
    bundle_not_enough: "Ikke nok på lager i {size}",
    bundle_not_enough_long: "Der er ikke nok af duftene på lager i {size} til en pakke.",
    bundle_name: "{count} × {size}",
    bundle_row_samples: "{count} × {size} prøver",
    bundle_save: "Spar {amount} ({pct} %)",
    samples_all: "alle {count}",
    samples_some: "de {count}",
    samples_link: "Eller prøv {who} som {size}-prøver for {price}",
    item_line: "{size} · {name} · {price}",
    item_missing: "{code} · ikke på lager i {size}",
    bundle_note: "Rabatten trækkes automatisk i kurven.",
    free_shipping: "Fri fragt over {amount}",
    status_added: "{title} ({size}) er lagt i kurven.",
    status_sold_out: "{title} er desværre udsolgt i {size}.",
    status_add_error: "Vi kunne ikke lægge duften i kurven. Prøv igen.",
    status_bundle_added: "Pakken er lagt i kurven.",
    status_samples_added: "De {count} prøver er lagt i kurven.",
    status_discount: "{what} Rabatten på {amount} trækkes automatisk.",
    status_bundle_changed: "En af duftene er lige blevet udsolgt i den størrelse. Pakken er opdateret – prøv igen.",
    status_bundle_error: "Vi kunne ikke lægge pakken i kurven. Prøv igen.",
    email_title: "Send mine matches til mig",
    email_text: "Få dine dufte i indbakken, så du nemt kan finde dem igen.",
    email_label: "E-mail",
    email_send: "Send",
    email_consent: "Ja tak til tilbud og nyheder fra Purabelle på e-mail",
    email_invalid: "Skriv en gyldig e-mailadresse.",
    email_rejected: "Den e-mailadresse kunne vi ikke bruge. Tjek den og prøv igen.",
    email_error: "Vi kunne ikke sende dine matches lige nu. Prøv igen om lidt – dine resultater bliver stående her.",
    email_sent: "Tak! Dine matches er på vej til {email}.",
    retake: "Tag quizzen igen",
    error_title: "Noget gik galt",
    error_default: "Vi kunne ikke få kontakt til quizzen lige nu. Dine svar er gemt.",
    retry: "Prøv igen",
    error_shared: "Vi kunne ikke hente resultatet lige nu.",
    notice_shared_missing: "Vi kunne ikke finde det resultat. Tag quizzen for at finde dine egne matches.",
    error_config: "Vi kunne ikke hente quizzen lige nu. Dine svar er gemt.",
    error_start: "Vi kunne ikke starte quizzen lige nu. Prøv igen om et øjeblik.",
    error_outdated: "Quizzen er blevet opdateret, siden du startede. Tag den venligst forfra.",
    error_result: "Vi kunne ikke beregne dine matches lige nu. Dine svar er gemt.",
  };

  /** Udfylder {navn} i en tekst. */
  const fill = (text, vars = {}) => String(text).replace(/\{(\w+)\}/g, (all, key) => (key in vars ? vars[key] : all));

  /** Quizzens sprog: da, de eller sv efter Shopifys request.locale; dansk som fallback. */
  const LANGUAGES = ['da', 'de', 'sv'];
  /** Fra denne bredde vises det tidligere desktop-layout (variantknapper og pakkerækker). */
  const DESKTOP_QUERY = '(min-width: 990px)';
  const NUMBER_LOCALES = { da: 'da-DK', de: 'de-DE', sv: 'sv-SE' };
  /** Valutaer der vises i hele enheder, som butikken gør i DK og SE. */
  const WHOLE_UNIT_CURRENCIES = ['DKK', 'SEK', 'NOK'];

  /* ---------- Hjælpere ---------- */

  const storage = {
    read() {
      try {
        return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || null;
      } catch (error) {
        return null;
      }
    },
    write(state) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (error) {
        // Privat vindue eller fuld lagerplads: quizzen virker stadig, den
        // husker bare ikke svarene ved genindlæsning.
      }
    },
    clear() {
      try {
        window.localStorage.removeItem(STORAGE_KEY);
      } catch (error) {
        // Se ovenfor.
      }
    },
  };

  class ApiError extends Error {
    constructor(message, status) {
      super(message);
      this.status = status;
    }
  }

  async function api(path, options = {}) {
    const url = new URL(API_BASE + path, window.location.origin);
    Object.entries(options.query || {}).forEach(([key, value]) => url.searchParams.set(key, value));

    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

    let response;
    try {
      response = await fetch(url, {
        method: options.method || 'GET',
        headers: options.body
          ? { 'Content-Type': 'application/json', Accept: 'application/json' }
          : { Accept: 'application/json' },
        body: options.body ? JSON.stringify(options.body) : undefined,
        credentials: 'same-origin',
        signal: controller.signal,
      });
    } catch (error) {
      throw new ApiError(error.name === 'AbortError' ? 'timeout' : 'network', 0);
    } finally {
      window.clearTimeout(timer);
    }

    if (!response.ok) {
      let message = 'http_' + response.status;
      try {
        message = (await response.json()).error || message;
      } catch (error) {
        // Ikke JSON - behold statuskoden som besked.
      }
      throw new ApiError(message, response.status);
    }

    return response.status === 204 ? null : response.json();
  }

  const wait = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

  /** "100ml", "100 ml" og "100 ML" skal alle regnes for den samme variant. */
  const normalizeTitle = (title) => String(title || '').toLowerCase().replace(/\s+/g, '');

  function deviceType() {
    const coarse = window.matchMedia('(pointer: coarse)').matches;
    if (!coarse) return 'desktop';
    return window.innerWidth < 750 ? 'mobile' : 'tablet';
  }

  function randomId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  function utmParams() {
    const utm = {};
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (key.startsWith('utm_')) utm[key.slice(4)] = value.slice(0, 200);
    });
    return Object.keys(utm).length ? utm : null;
  }

  /** Shopify-CDN-billeder kan skaleres med width-parameteren. */
  function sizedImage(src, width) {
    if (!src) return '';
    try {
      const url = new URL(src, window.location.origin);
      if (!url.protocol.startsWith('http')) return src;
      url.searchParams.set('width', width);
      return url.toString();
    } catch (error) {
      return src;
    }
  }

  /* ---------- Tracking ---------- */

  const EVENT_FLUSH_MS = 2000;
  const EVENT_BATCH_SIZE = 10;
  const EVENT_MAX_BATCH = 50;

  /**
   * Samler events til /apps/quiz/event i små batches. Når siden forlades,
   * sendes resten med sendBeacon, som browseren gennemfører efter lukning.
   */
  class Tracker {
    constructor() {
      this.queue = [];
      this.timer = null;
    }

    push(sessionId, type, payload = {}) {
      if (!sessionId) return;
      this.queue.push({ session_id: sessionId, type, payload });
      if (this.queue.length >= EVENT_BATCH_SIZE) {
        this.flush();
      } else if (!this.timer) {
        this.timer = window.setTimeout(() => this.flush(), EVENT_FLUSH_MS);
      }
    }

    flush() {
      window.clearTimeout(this.timer);
      this.timer = null;
      if (!this.queue.length) return;

      const batch = this.queue.splice(0, EVENT_MAX_BATCH);
      api('/event', { method: 'POST', body: batch }).catch((error) => {
        // Netværksfejl: prøv igen med næste batch. Afviste events (400) droppes.
        if (error.status === 0 && this.queue.length + batch.length <= EVENT_MAX_BATCH) {
          this.queue.unshift(...batch);
        }
      });
      if (this.queue.length) this.flush();
    }

    /** Sender køen, mens siden lukker. text/plain kræver ingen preflight. */
    flushOnExit() {
      window.clearTimeout(this.timer);
      this.timer = null;
      while (this.queue.length) {
        const batch = JSON.stringify(this.queue.splice(0, EVENT_MAX_BATCH));
        const url = API_BASE + '/event';
        const sent =
          typeof navigator.sendBeacon === 'function' &&
          navigator.sendBeacon(url, new Blob([batch], { type: 'text/plain;charset=UTF-8' }));
        if (!sent) {
          fetch(url, { method: 'POST', body: batch, keepalive: true, credentials: 'same-origin' }).catch(() => {});
        }
      }
    }
  }

  /** Respekterer Shopifys cookie-samtykke, når det er slået til i butikken. */
  function consentAllows(kind) {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return true;
    try {
      return kind === 'marketing' ? privacy.marketingAllowed() : privacy.analyticsProcessingAllowed();
    } catch (error) {
      return true;
    }
  }

  /** Sender en gennemført quiz til de sporingsværktøjer, der findes på siden. */
  function trackCompletionElsewhere(state) {
    const answers = state.answers || {};
    const results = state.results || [];
    const params = {
      familie: (answers.familie || []).join(', '),
      koen: answers.koen || '',
      intensitet: answers.intensitet || '',
      prioritet: answers.prioritet || '',
      quiz_version: state.quiz_version || '',
    };

    const attempt = (fn) => {
      try {
        fn();
      } catch (error) {
        // En fejl i et sporingsværktøj må aldrig ramme quizzen.
      }
    };

    // Shopify-kundeevent: kan opfanges af en custom pixel under
    // Indstillinger > Kundeevents. Shopify håndhæver selv samtykket her.
    attempt(() => {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('quiz_complete', {
          ...params,
          session_id: state.session_id,
          language: state.language || '',
          market: state.market || '',
          product_ids: results.map((result) => result.product_id),
        });
      }
    });

    if (consentAllows('marketing')) {
      attempt(() => {
        if (typeof window.fbq === 'function') window.fbq('trackCustom', 'QuizComplete', params);
      });
      attempt(() => {
        if (window.klaviyo && typeof window.klaviyo.push === 'function') {
          window.klaviyo.push([
            'track',
            'Completed Quiz',
            {
              Familie: answers.familie || [],
              Noter: answers.noter || [],
              Køn: params.koen,
              Intensitet: params.intensitet,
              Prioritet: params.prioritet,
              Tidspunkt: answers.tidspunkt || '',
              Indtryk: answers.indtryk || '',
              'Top match': results[0] ? results[0].title : null,
              Matches: results.map((result) => result.title),
              'Quiz session': state.session_id,
              'Quiz version': params.quiz_version,
              Sprog: state.language || '',
              Marked: state.market || '',
            },
          ]);
        }
      });
    }

    if (consentAllows('analytics')) {
      attempt(() => {
        if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'quiz_complete', ...params });
      });
    }
  }

  /** Mængderabat for antal stk.: højeste trin, der ikke overstiger antallet. */
  function discountFor(tiers, count) {
    let pct = 0;
    let bedste = 0;
    Object.entries(tiers || {}).forEach(([antal, procent]) => {
      const n = Number(antal);
      if (n <= count && n > bedste) {
        bedste = n;
        pct = Number(procent) || 0;
      }
    });
    return pct;
  }

  /** "H540 - Inspireret af Baccarat Rouge 540" -> "H540 · Baccarat Rouge 540" (også tysk og svensk). */
  const shortTitle = (title) =>
    String(title || '').replace(/\s*[-–]\s*(inspireret af|inspiriert von|inspirerad av)\s*/i, ' · ');

  /** Duftkoden forrest i titlen, fx "D311"; ellers den korte titel. */
  const productCode = (title) => {
    const match = String(title || '').match(/^([A-ZÆØÅ]\d{1,4})\b/);
    return match ? match[1] : shortTitle(title);
  };

  /** "H299 - Inspireret af Ombre Nomade" -> "H299 Inspireret af Ombre Nomade". */
  const fullName = (title) => String(title || '').replace(/^([A-ZÆØÅ]\d{1,4})\s*[-–]\s*/, '$1 ');

  /** "30ml" -> "30 ml" til visning. */
  const sizeLabel = (title) => String(title).replace(/(\d)\s*ml$/i, '$1 ml');

  /**
   * Teksterne fra temaets locale-filer, som sektionen skriver ud med t-filteret.
   * Mangler en nøgle, skriver Shopify "translation missing"; så bruges dansk.
   */
  function readTranslations(root) {
    const el = root.querySelector('[data-pq-i18n]');
    if (!el) return {};
    try {
      const data = JSON.parse(el.textContent);
      return Object.fromEntries(
        Object.entries(data).filter(
          ([, value]) => typeof value === 'string' && value && !/translation missing/i.test(value)
        )
      );
    } catch (error) {
      return {};
    }
  }

  /** Parametre, som forsidens banner kan sende første svar med (?koen=Maskulin). */
  const ENTRY_QUESTIONS = ['koen'];

  function freshState(sessionId, quizVersion) {
    return {
      session_id: sessionId,
      quiz_version: quizVersion,
      answers: {},
      step: 0,
      results: null,
      completed: false,
    };
  }

  /* ---------- Quizzen ---------- */

  class Quiz {
    constructor(root) {
      this.root = root;
      this.uid = Math.random().toString(36).slice(2, 8);
      this.market = root.dataset.market || 'DK';
      this.currency = root.dataset.currency || 'DKK';
      const lang = String(root.dataset.lang || 'da').slice(0, 2).toLowerCase();
      this.lang = LANGUAGES.includes(lang) ? lang : 'da';
      this.text = { ...DEFAULT_TEXT, ...readTranslations(root) };
      this.freeShipping = Number(root.dataset.freeShipping) || 0;
      // Priser og titler hentes fra butikken (markedets valuta); indtil da vises ingen priser.
      this.marketDataReady = false;
      this.rootUrl = root.dataset.root || '/';
      this.sampleTitle = normalizeTitle(root.dataset.sampleTitle || '3ml');
      this.state = storage.read();
      this.config = null;
      this.configPromise = null;
      this.retryAction = null;
      this.screen = 'start';
      this.bundleSize = null;
      this.tracker = new Tracker();
      this.viewedAt = Date.now();
      this.viewId = null;
      this.questionShownAt = 0;
      this.abandonSent = false;

      const $ = (selector) => root.querySelector(selector);
      this.el = {
        screens: root.querySelectorAll('[data-screen]'),
        notice: $('[data-notice]'),
        startButton: $('[data-action="start"]'),
        progressLabel: $('[data-progress-label]'),
        progressBar: $('[data-progress-bar]'),
        content: $('[data-question-content]'),
        questionLabel: $('[data-question-label]'),
        questionHint: $('[data-question-hint]'),
        options: $('[data-options]'),
        nextButton: $('[data-action="next"]'),
        resultTitle: $('[data-result-title]'),
        cartStatus: $('[data-cart-status]'),
        cards: $('[data-cards]'),
        cardTemplate: $('[data-card-template]'),
        resultLead: $('[data-result-lead]'),
        resultNote: $('[data-result-note]'),
        bundle: $('[data-bundle]'),
        bundleTitle: $('[data-bundle-title]'),
        sizeToggle: $('[data-size-toggle]'),
        bundleSizes: $('[data-bundle-sizes]'),
        bundlePrice: $('[data-bundle-price]'),
        samplesButton: $('[data-action="add-samples"]'),
        bundleMissing: $('[data-bundle-missing]'),
        bundleButtons: root.querySelectorAll('[data-action="add-bundle"]'),
        bundleItems: $('[data-bundle-items]'),
        bundleNote: $('[data-bundle-note]'),
        stickyBar: $('[data-sticky-bar]'),
        emailForm: $('[data-email-form]'),
        emailFields: $('[data-email-fields]'),
        emailStatus: $('[data-email-status]'),
        errorTitle: $('[data-error-title]'),
        errorText: $('[data-error-text]'),
      };
    }

    get questions() {
      return this.config ? this.config.questions : [];
    }

    get question() {
      return this.questions[this.state.step];
    }

    url(path) {
      return (this.rootUrl.endsWith('/') ? this.rootUrl : this.rootUrl + '/') + path;
    }

    /** Tekst på kundens sprog fra temaets locale-filer, ellers dansk. */
    t(key, vars) {
      return fill(this.text[key] ?? DEFAULT_TEXT[key] ?? key, vars);
    }

    /** Faste tekster i markup'en (data-i18n="nøgle") oversættes ved start. */
    applyStaticText() {
      this.root.querySelectorAll('[data-i18n]').forEach((el) => {
        el.textContent = this.t(el.dataset.i18n);
      });
      this.root.querySelectorAll('[data-i18n-label]').forEach((el) => {
        el.setAttribute('aria-label', this.t(el.dataset.i18nLabel));
      });
    }

    save() {
      // Et delt resultat må ikke overskrive den besøgendes egen quiz.
      if (this.state && !this.state.shared) storage.write(this.state);
    }

    track(type, payload) {
      if (this.state) this.tracker.push(this.state.session_id, type, payload);
    }

    /**
     * quiz_view sendes, før der findes en session, så besøgende der aldrig
     * starter også tælles. view_id går igen på quiz_start, så de kan kobles.
     */
    trackAnonymousView(source) {
      this.viewId = randomId();
      this.viewedAt = Date.now();
      const payload = { view_id: this.viewId, device: deviceType(), market: this.market };
      if (source) payload.source = source;
      api('/event', {
        method: 'POST',
        body: { type: 'quiz_view', payload },
      }).catch(() => {
        // Tracking må aldrig forstyrre quizzen.
      });
    }

    /* ----- Opstart ----- */

    init() {
      this.root.classList.add('pq--js');
      this.applyStaticText();
      this.root.addEventListener('click', (event) => this.onClick(event));
      if (this.el.emailForm) {
        this.el.emailForm.addEventListener('submit', (event) => this.submitEmail(event));
      }
      if (this.el.bundleSizes) {
        this.el.bundleSizes.addEventListener('change', (event) => {
          this.setSize(event.target.value);
          this.track('bundle_size_select', { size: event.target.value, source: 'bundle' });
        });
      }
      if (this.el.cards) {
        this.el.cards.addEventListener('change', (event) => this.onCardSizeChange(event.target));
      }
      // Skifter skærmen mellem mobil- og desktop-layout, tegnes kort og pakke om.
      this.desktopQuery = window.matchMedia(DESKTOP_QUERY);
      this.desktopQuery.addEventListener('change', () => {
        if (this.screen === 'result') this.renderBundle();
      });
      if (this.el.sizeToggle) {
        this.el.sizeToggle.addEventListener('change', (event) => {
          this.setSize(event.target.value);
          this.track('bundle_size_select', { size: event.target.value, source: 'toggle' });
        });
      }

      const params = new URLSearchParams(window.location.search);
      const sharedId = params.get('session');
      const entryId = sharedId ? null : ENTRY_QUESTIONS.find((id) => params.get(id));

      if (entryId) {
        this.startFromEntry(entryId, params.get(entryId));
        return;
      }

      if (sharedId) {
        if (this.state && this.state.session_id === sharedId && this.state.results) {
          this.track('quiz_view', { revisit: true });
          this.showResult({ focus: false, revisit: true });
          return;
        }
        this.loadShared(sharedId);
        return;
      } else if (this.state && this.state.session_id && !this.state.completed) {
        this.track('quiz_view', { resumed: true, step: this.state.step });
        this.resume();
        return;
      }

      this.trackAnonymousView();
      this.show('start');
      this.loadConfig().catch(() => {
        // Hentes igen, når kunden trykker start.
      });
    }

    /**
     * Et delt link fra en anden enhed: resultatet hentes fra backenden og vises
     * uden at overskrive denne besøgendes egen quiz i localStorage.
     */
    async loadShared(sessionId) {
      this.show('loading');
      let data;
      try {
        data = await api('/result', { query: { session_id: sessionId, lang: this.lang } });
      } catch (error) {
        if (error.status === 0 || error.status >= 500) {
          this.showError(this.t('error_shared'), () => this.loadShared(sessionId));
          return;
        }
        // 400/404: ukendt eller ikke gennemført session.
        this.setNotice(this.t('notice_shared_missing'));
        this.removeSessionParam();
        this.trackAnonymousView();
        this.show('start');
        this.loadConfig().catch(() => {});
        return;
      }

      this.state = {
        ...freshState(sessionId, null),
        results: (data.results || []).slice(0, 4),
        completed: true,
        shared: true,
      };
      this.track('quiz_view', { shared: true });
      this.showResult({ focus: false, revisit: true });
    }

    /** Fortsætter en påbegyndt quiz efter genindlæsning. */
    async resume({ focus = false } = {}) {
      try {
        await this.loadConfig();
      } catch (error) {
        this.track('abandon', { reason: 'api_error', stage: 'config', error: error.message });
        this.showError(this.t('error_config'), () => this.resume({ focus: true }));
        return;
      }
      if (!this.state || !this.state.session_id) {
        this.show('start');
        return;
      }
      if (this.state.step >= this.questions.length) {
        this.submit();
      } else {
        this.showQuestion(this.state.step, { focus });
      }
    }

    loadConfig() {
      if (!this.configPromise) {
        this.configPromise = api('/config', { query: { market: this.market, lang: this.lang } })
          .then((config) => {
            this.config = config;
            // Er quizzen ændret siden sidst, passer de gemte svar ikke længere.
            if (this.state && this.state.quiz_version !== config.quiz_version && !this.state.completed) {
              this.state = freshState(this.state.session_id, config.quiz_version);
              this.save();
            }
            return config;
          })
          .catch((error) => {
            this.configPromise = null;
            throw error;
          });
      }
      return this.configPromise;
    }

    async createSession() {
      const data = await api('/session', {
        method: 'POST',
        body: {
          landing_url: window.location.href,
          referrer: document.referrer || null,
          utm: utmParams(),
          device: deviceType(),
          market: this.market,
          language: this.lang,
        },
      });
      return data.session_id;
    }

    /* ----- Navigation ----- */

    onClick(event) {
      const option = event.target.closest('[data-value]');
      if (option && this.el.options.contains(option)) {
        this.choose(option.dataset.value);
        return;
      }

      const productLink = event.target.closest('[data-link]');
      if (productLink && this.el.cards.contains(productLink)) {
        const index = Number(productLink.closest('.pq-card').dataset.index);
        const result = this.state.results[index];
        if (result) this.track('product_click', { product_id: result.product_id, position: index + 1 });
        return;
      }

      const trigger = event.target.closest('[data-action]');
      if (!trigger || !this.root.contains(trigger)) return;

      switch (trigger.dataset.action) {
        case 'start':
          this.start();
          break;
        case 'back':
          this.back();
          break;
        case 'next':
          this.advance();
          break;
        case 'add':
          this.addToCart(Number(trigger.dataset.index), trigger);
          break;
        case 'add-bundle':
          this.addBundle(trigger);
          break;
        case 'add-samples':
          this.addBundle(trigger, this.sampleBundle());
          break;
        case 'retake':
          this.retake();
          break;
        case 'retry':
          if (this.retryAction) this.retryAction();
          break;
        default:
          break;
      }
    }

    async start() {
      // En påbegyndt session genbruges, fx hvis kunden gik tilbage til start.
      if (this.state && this.state.session_id && !this.state.completed) {
        await this.resume({ focus: true });
        return;
      }

      this.setBusy(this.el.startButton, true);
      try {
        const [config, sessionId] = await Promise.all([this.loadConfig(), this.createSession()]);
        this.state = { ...freshState(sessionId, config.quiz_version), language: this.lang, market: this.market };
        this.save();
        this.abandonSent = false;
        this.track('quiz_start', {
          device: deviceType(),
          market: this.market,
          view_id: this.viewId,
          ms_before_start: this.viewId ? Date.now() - this.viewedAt : null,
        });
        this.viewId = null;
        this.setNotice('');
        this.showQuestion(0);
      } catch (error) {
        this.showError(this.t('error_start'), () => this.start());
      } finally {
        this.setBusy(this.el.startButton, false);
      }
    }

    /**
     * Kunden har svaret på første spørgsmål i forsidens banner. Svaret gemmes og
     * logges som et almindeligt answer-event, og quizzen starter på spørgsmål 2.
     * Et ukendt svar ignoreres, og startskærmen vises som normalt.
     */
    async startFromEntry(questionId, value) {
      this.removeParam(questionId);
      this.root.classList.add('pq--entry');
      this.show('loading');
      if (!this.viewId) this.trackAnonymousView('homepage');
      const sessionPromise = this.createSession();
      sessionPromise.catch(() => {});
      try {
        const config = await this.loadConfig();
        const index = config.questions.findIndex((question) => question.id === questionId);
        const question = config.questions[index];
        const valid = index === 0 && question.options.some((option) => option.value === value);
        if (!valid) {
          this.root.classList.remove('pq--entry');
          this.show('start');
          return;
        }

        const sessionId = await sessionPromise;
        this.state = { ...freshState(sessionId, config.quiz_version), language: this.lang, market: this.market };
        this.state.answers[questionId] = question.type === 'multi' ? [value] : value;
        this.save();
        this.abandonSent = false;
        this.track('quiz_start', {
          device: deviceType(),
          market: this.market,
          source: 'homepage',
          view_id: this.viewId,
          ms_before_start: this.viewId ? Date.now() - this.viewedAt : null,
        });
        this.track('answer', {
          question: questionId,
          answer: this.state.answers[questionId],
          skipped: false,
          step: 1,
          ms: null,
          source: 'homepage',
        });
        this.viewId = null;
        this.setNotice('');
        this.root.classList.remove('pq--entry');
        this.showQuestion(index + 1, { focus: false });
      } catch (error) {
        this.root.classList.remove('pq--entry');
        this.showError(this.t('error_start'), () => this.startFromEntry(questionId, value));
      }
    }

    back() {
      this.track('back', { from: this.question.id, step: this.state.step + 1 });
      if (this.state.step === 0) {
        this.show('start');
        this.el.startButton.focus();
        return;
      }
      this.showQuestion(this.state.step - 1);
    }

    advance() {
      const question = this.question;
      const skipped = question.type === 'multi' && !(this.state.answers[question.id] || []).length;
      if (skipped) {
        this.state.answers[question.id] = [];
        this.save();
      }
      this.track('answer', {
        question: question.id,
        answer: this.state.answers[question.id],
        skipped,
        step: this.state.step + 1,
        ms: Date.now() - this.questionShownAt,
      });

      const next = this.state.step + 1;
      if (next < this.questions.length) {
        this.showQuestion(next);
      } else {
        this.state.step = next;
        this.save();
        this.submit();
      }
    }

    async retake() {
      this.track('retake', {});
      this.tracker.flush();
      this.viewId = null;
      this.state = null;
      storage.clear();
      this.removeSessionParam();
      await this.start();
    }

    /* ----- Spørgsmål ----- */

    showQuestion(index, { focus = true } = {}) {
      this.state.step = index;
      this.save();
      this.questionShownAt = Date.now();

      const question = this.question;
      const total = this.questions.length;
      const multi = question.type === 'multi';
      const max = question.max_select || question.options.length;

      this.el.progressLabel.textContent = this.t('progress', { n: index + 1, total });
      this.el.progressBar.style.width = `${((index + 1) / total) * 100}%`;
      this.el.questionLabel.textContent = question.label;
      this.el.questionHint.textContent = question.hint || (multi ? this.t('choose_up_to', { max }) : '');
      this.el.options.setAttribute('aria-label', question.label);
      this.el.options.dataset.count = String(question.options.length);

      this.el.options.replaceChildren(
        ...question.options.map((option) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'pq-option';
          button.dataset.value = option.value;

          const label = document.createElement('span');
          label.className = 'pq-option__label';
          // Tillad linjeskift efter skråstreg, fx "Bergamot/citrus" på smalle skærme.
          label.textContent = option.label.replace(/\//g, '/\u200B');
          button.append(label);

          if (option.description) {
            const description = document.createElement('span');
            description.className = 'pq-option__desc';
            description.textContent = option.description;
            button.append(description);
          }
          return button;
        })
      );

      this.el.nextButton.classList.toggle('pq-is-unused', !multi);
      this.refreshSelection();

      if (this.screen === 'question') {
        // Genstarter overgangen for det nye spørgsmål.
        this.el.content.classList.remove('pq-is-entering');
        void this.el.content.offsetWidth;
        this.el.content.classList.add('pq-is-entering');
      }
      this.show('question');
      if (focus) this.focus(this.el.questionLabel);
    }

    /** Opdaterer valgte svarkort og Næste-knappen ud fra de gemte svar. */
    refreshSelection() {
      const question = this.question;
      const answer = this.state.answers[question.id];
      const selected = Array.isArray(answer) ? answer : answer ? [answer] : [];
      const multi = question.type === 'multi';
      const full = multi && selected.length >= (question.max_select || question.options.length);

      this.el.options.querySelectorAll('.pq-option').forEach((button) => {
        const isSelected = selected.includes(button.dataset.value);
        button.setAttribute('aria-pressed', String(isSelected));
        button.disabled = full && !isSelected;
      });

      // Et valgfrit spørgsmål kan springes over; knappen siger det så.
      const optional = multi && question.required === false;
      this.el.nextButton.disabled = multi ? selected.length === 0 && !optional : true;
      this.el.nextButton.textContent = optional && selected.length === 0 ? this.t('skip') : this.t('next');
    }

    choose(value) {
      const question = this.question;

      if (question.type === 'multi') {
        const current = this.state.answers[question.id] || [];
        const max = question.max_select || question.options.length;
        let next;
        if (current.includes(value)) {
          next = current.filter((entry) => entry !== value);
        } else if (current.length < max) {
          next = current.concat(value);
        } else {
          return;
        }
        this.state.answers[question.id] = next;
        this.save();
        this.refreshSelection();
        return;
      }

      this.state.answers[question.id] = value;
      this.save();
      this.refreshSelection();

      // Kort pause, så kunden kan se sit valg, før næste spørgsmål glider ind.
      this.el.options.querySelectorAll('.pq-option').forEach((button) => {
        button.disabled = true;
      });
      window.setTimeout(() => this.advance(), ADVANCE_DELAY_MS);
    }

    /* ----- Beregning ----- */

    async submit() {
      this.show('loading');
      try {
        const [data] = await Promise.all([
          api('/result', {
            method: 'POST',
            body: { session_id: this.state.session_id, answers: this.state.answers },
          }),
          wait(MIN_LOADING_MS),
        ]);
        this.state.results = (data.results || []).slice(0, 4);
        this.state.completed = true;
        this.save();
        // quiz_complete logges af backenden i /result og sendes derfor ikke herfra.
        trackCompletionElsewhere(this.state);
        this.showResult();
      } catch (error) {
        if (error.status === 400) {
          // Ukendt session eller svar, der ikke længere passer til quizzen.
          this.state = null;
          storage.clear();
          this.showError(this.t('error_outdated'), () =>
            this.start()
          );
          return;
        }
        this.track('abandon', { reason: 'api_error', stage: 'result', error: error.message });
        this.showError(this.t('error_result'), () => this.submit());
      }
    }

    /* ----- Resultat ----- */

    showResult({ focus = true, revisit = false } = {}) {
      const results = this.state.results || [];
      this.track('result_view', {
        product_ids: results.map((result) => result.product_id),
        revisit,
      });

      const count = results.length;
      this.setCartStatus('');
      this.renderCards();
      this.el.resultTitle.textContent =
        count === 0
          ? this.t('result_title_none')
          : count === 1
            ? this.t('result_title_one')
            : this.t('result_title_many', { count });
      this.el.resultLead.hidden = count === 0;

      // Pakkerabatterne kommer fra /config, som ikke er hentet ved et genbesøg.
      this.bundleSize = null;
      this.setBundleVisible(false);
      // Backendens priser er i DKK og kan vises med det samme i Danmark. I andre
      // markeder vises priser først, når de er hentet fra markedets butik.
      this.marketDataReady = this.currency === 'DKK';
      this.loadMarketData().then(() => {
        this.renderCards();
        this.renderBundle();
      });
      if (this.el.resultNote) this.el.resultNote.hidden = true;
      if (this.el.sizeToggle) this.el.sizeToggle.hidden = true;
      this.loadConfig()
        .then(() => {
          this.renderResultNote();
          this.renderBundle();
        })
        .catch(() => {
          // Uden config vises kortene alene, med størrelserne fra varianterne.
          this.renderSizeToggle();
          this.updateCards();
        });

      this.resetEmailBox();
      this.setSessionParam(this.state.session_id);
      this.show('result');
      if (focus) this.focus(this.el.resultTitle);
    }

    renderCards() {
      const results = this.state.results || [];
      this.el.cards.dataset.count = String(results.length);
      this.el.cards.replaceChildren(...results.map((result, index) => this.renderCard(result, index)));
      this.updateCards();
    }

    renderCard(result, index) {
      const card = this.el.cardTemplate.content.firstElementChild.cloneNode(true);
      const $ = (selector) => card.querySelector(selector);
      const productUrl = result.handle ? this.url('products/' + result.handle) : null;

      card.dataset.index = String(index);
      card.classList.toggle('pq-card--top', index === 0);
      $('[data-badge]').hidden = index !== 0;
      $('[data-badge]').textContent = this.t('best_match');
      $('[data-match]').textContent = this.t('match_pct', { pct: result.match_pct });
      $('[data-title]').textContent = result.title || '';
      $('[data-title-short]').textContent = shortTitle(result.title);
      $('[data-notes]').textContent = result.noegle_noter ? this.t('notes', { notes: result.noegle_noter }) : '';

      card.querySelectorAll('[data-link]').forEach((link) => {
        if (productUrl) link.href = productUrl;
        else link.removeAttribute('href');
      });

      const image = $('[data-img]');
      if (result.image_url) {
        image.src = sizedImage(result.image_url, 300);
        image.srcset = [200, 300, 450].map((w) => `${sizedImage(result.image_url, w)} ${w}w`).join(', ');
        image.sizes = '(min-width: 750px) 128px, 96px';
        if (index === 0) image.loading = 'eager';
      } else {
        $('.pq-card__media').remove();
      }

      $('[data-reasons]').replaceChildren(
        ...(result.reasons || []).slice(0, 3).map((reason) => {
          const item = document.createElement('li');
          item.textContent = reason;
          return item;
        })
      );

      $('[data-action="add"]').dataset.index = String(index);
      return card;
    }

    isSample(variant) {
      return normalizeTitle(variant.title) === this.sampleTitle;
    }

    formatPrice(amount) {
      try {
        return new Intl.NumberFormat(NUMBER_LOCALES[this.lang], {
          style: 'currency',
          currency: this.currency,
          minimumFractionDigits: WHOLE_UNIT_CURRENCIES.includes(this.currency) && Number.isInteger(amount) ? 0 : 2,
        }).format(amount);
      } catch (error) {
        return `${amount} ${this.currency}`;
      }
    }

    /* ----- Kurv ----- */

    /** Lægger kortets duft i kurven i den størrelse, toggle'en står på. */
    async addToCart(index, button) {
      const result = this.state.results[index];
      const card = this.el.cards.children[index];
      const valgt = this.isDesktop() && card && card.querySelector('.pq-variant input:checked');
      const variant = valgt
        ? (result.variants || []).find((v) => String(v.id) === valgt.value) || null
        : result && this.selectedSize()
          ? this.variantFor(result, this.selectedSize())
          : null;
      const size = variant ? variant.title : this.selectedSize();
      if (!variant || !variant.available) return;

      this.setBusy(button, true);
      try {
        await this.cartAdd([variant.id], result.product_id);
        this.track('add_to_cart', { product_id: result.product_id, variant_id: variant.id, size, position: index + 1 });
        this.setCartStatus(this.t('status_added', { title: shortTitle(result.title), size: sizeLabel(size) }));
        this.setBusy(button, false);
        this.updateCard(card, result, size);
        this.flashAdded(button);
      } catch (error) {
        this.setBusy(button, false);
        if (error.status === 422) {
          this.markSoldOut(variant.id);
          this.setCartStatus(this.t('status_sold_out', { title: shortTitle(result.title), size: sizeLabel(size) }), true);
        } else {
          this.updateCard(card, result, size);
          this.setCartStatus(this.t('status_add_error'), true);
        }
      }
    }

    /**
     * Tekster knyttet til de valgte svar (result_note i config), fx at alle
     * matches holder hele dagen. Et delt resultat har ingen svar og viser intet.
     */
    renderResultNote() {
      const note = this.el.resultNote;
      if (!note || !(this.state.results || []).length) return;
      const answers = this.state.answers || {};
      const texts = this.questions.flatMap((question) => {
        const answer = answers[question.id];
        const chosen = Array.isArray(answer) ? answer : answer ? [answer] : [];
        return question.options
          .filter((option) => option.result_note && chosen.includes(option.value))
          .map((option) => option.result_note);
      });
      note.textContent = texts.join(' ');
      note.hidden = !texts.length;
    }

    /* ----- Størrelse og pakke ----- */

    bundleSizes() {
      const discounts = this.config && this.config.bundle_discounts;
      return discounts && Array.isArray(discounts.sizes) ? discounts.sizes : [];
    }

    sizeConfig(variantTitle) {
      return this.bundleSizes().find((size) => size.variant_title === variantTitle) || null;
    }

    isDesktop() {
      return Boolean(this.desktopQuery && this.desktopQuery.matches);
    }

    /**
     * De størrelser kunden kan vælge. Mobil (toggle'en): 30 ml og 100 ml. Desktop
     * (pakkens rækker): også prøverne. Uden config: størrelserne på kortene.
     */
    sizeOptions() {
      const medProever = this.isDesktop();
      const fromConfig = this.bundleSizes()
        .map((size) => size.variant_title)
        .filter((title) => medProever || normalizeTitle(title) !== this.sampleTitle);
      if (fromConfig.length) return fromConfig;

      const seen = new Map();
      (this.state.results || []).forEach((result) =>
        (result.variants || []).forEach((variant) => {
          const key = normalizeTitle(variant.title);
          if ((medProever || !this.isSample(variant)) && !seen.has(key)) seen.set(key, variant);
        })
      );
      return [...seen.values()].sort((a, b) => a.price - b.price).map((variant) => variant.title);
    }

    /** Den valgte størrelse: kundens valg, ellers default_size, ellers den største. */
    selectedSize() {
      const options = this.sizeOptions();
      if (this.bundleSize && options.includes(this.bundleSize)) return this.bundleSize;
      const discounts = this.config && this.config.bundle_discounts;
      const fallback = discounts && discounts.default_size;
      return options.includes(fallback) ? fallback : options[options.length - 1] || null;
    }

    variantFor(result, variantTitle) {
      const wanted = normalizeTitle(variantTitle);
      return (result.variants || []).find((variant) => normalizeTitle(variant.title) === wanted) || null;
    }

    renderSizeToggle() {
      const toggle = this.el.sizeToggle;
      if (!toggle) return;
      const options = this.sizeOptions();
      const selected = this.selectedSize();
      if (options.length < 2 || !(this.state.results || []).length) {
        toggle.hidden = true;
        return;
      }
      const legend = toggle.querySelector('legend');
      toggle.replaceChildren(
        legend,
        ...options.map((title) => {
          const label = document.createElement('label');
          label.className = 'pq-size-toggle__option';
          const input = document.createElement('input');
          input.type = 'radio';
          input.name = `pq-size-${this.uid}`;
          input.value = title;
          input.checked = title === selected;
          const text = document.createElement('span');
          text.textContent = sizeLabel(title);
          label.append(input, text);
          return label;
        })
      );
      toggle.hidden = false;
    }

    /** Toggle'en, en pakkerække eller et kort skifter størrelse: resten følger med. */
    setSize(variantTitle) {
      this.bundleSize = variantTitle;
      this.updateCards();
      this.updateBundle();
      if (this.el.bundleSizes) {
        this.el.bundleSizes.querySelectorAll('input').forEach((input) => {
          input.checked = input.value === this.selectedSize();
        });
      }
    }

    updateCards() {
      const size = this.selectedSize();
      Array.from(this.el.cards.children).forEach((card, index) => {
        const result = (this.state.results || [])[index];
        if (result) this.updateCard(card, result, size);
      });
    }

    /**
     * Pris og knap på et kort for den valgte størrelse. Mobil: udsolgt giver en grå
     * knap. Desktop: kortets størrelsesknap sættes til størrelsen eller nærmeste på lager.
     */
    updateCard(card, result, size) {
      if (this.isDesktop()) {
        this.updateCardDesktop(card, result, size);
        return;
      }
      const price = card.querySelector('[data-price]');
      const button = card.querySelector('[data-action="add"]');
      const variant = size ? this.variantFor(result, size) : null;
      const label = size ? sizeLabel(size) : '';
      const available = Boolean(variant && variant.available);

      price.textContent = variant ? this.t('card_price', { size: label, price: this.formatKr(variant.price) }) : '';
      price.hidden = !variant || !this.marketDataReady;
      card.classList.toggle('pq-card--soldout', Boolean(size) && !available);

      if (button.getAttribute('aria-busy') === 'true') return;
      button.disabled = !available;
      button.textContent = available
        ? this.t('add_to_cart')
        : label
          ? this.t('sold_out_in', { size: label })
          : this.t('sold_out');
    }

    updateCardDesktop(card, result, size) {
      const variants = this.sortedVariants(result.variants);
      const fieldset = card.querySelector('[data-variants]');
      if (fieldset && !fieldset.querySelector('input')) {
        variants.forEach((variant) => fieldset.append(this.renderVariant(variant, Number(card.dataset.index))));
      }
      if (fieldset) {
        fieldset.querySelectorAll('.pq-variant').forEach((label) => {
          const input = label.querySelector('input');
          const variant = variants.find((v) => String(v.id) === input.value);
          input.disabled = !variant || !variant.available;
          label.querySelector('small').textContent =
            variant && variant.available ? (this.marketDataReady ? this.formatKr(variant.price) : '') : this.t('sold_out');
        });
      }
      const valgt = size ? this.variantNear(variants, size) : this.defaultVariant(variants);
      const input = valgt && card.querySelector(`.pq-variant input[value="${valgt.id}"]`);
      if (input) input.checked = true;
      card.classList.remove('pq-card--soldout');
      this.refreshDesktopButton(card);
    }

    /** Desktop: knappen følger kortets valgte størrelse. */
    refreshDesktopButton(card) {
      const button = card.querySelector('[data-action="add"]');
      if (!button || button.getAttribute('aria-busy') === 'true') return;
      const valgt = card.querySelector('.pq-variant input:checked');
      button.disabled = !valgt;
      button.textContent = valgt ? this.t('add_to_cart') : this.t('sold_out');
    }

    /** "3 ml" med pris under; udsolgt står gennemstreget. */
    renderVariant(variant, cardIndex) {
      const label = document.createElement('label');
      label.className = 'pq-variant';
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = `pq-${this.uid}-${cardIndex}`;
      input.value = String(variant.id);
      const text = document.createElement('span');
      text.append(sizeLabel(variant.title));
      const detail = document.createElement('small');
      text.append(detail);
      label.append(input, text);
      return label;
    }

    /** Prøve først, derefter efter pris: 3 ml, 30 ml, 100 ml. */
    sortedVariants(variants) {
      return (variants || []).slice().sort((a, b) => {
        const aSample = this.isSample(a) ? 0 : 1;
        const bSample = this.isSample(b) ? 0 : 1;
        return aSample - bSample || a.price - b.price;
      });
    }

    /** Varianten i størrelsen, eller nærmeste størrelse på lager (ved lige afstand den største). */
    variantNear(variants, variantTitle) {
      const wanted = normalizeTitle(variantTitle);
      const target = variants.findIndex((variant) => normalizeTitle(variant.title) === wanted);
      if (target === -1) return this.defaultVariant(variants);
      const available = variants
        .map((variant, index) => ({ variant, index }))
        .filter(({ variant }) => variant.available)
        .sort((a, b) => Math.abs(a.index - target) - Math.abs(b.index - target) || b.index - a.index);
      return available.length ? available[0].variant : null;
    }

    /** Den billigste fulde flaske på lager, ellers den første på lager. */
    defaultVariant(variants) {
      const available = variants.filter((variant) => variant.available);
      return available.find((variant) => !this.isSample(variant)) || available[0] || null;
    }

    /** Desktop: et kort skifter størrelse - pakken og de andre kort følger med. */
    onCardSizeChange(input) {
      if (!input.matches('.pq-variant input')) return;
      const card = input.closest('.pq-card');
      const result = (this.state.results || [])[Number(card.dataset.index)];
      const variant = result && (result.variants || []).find((v) => String(v.id) === input.value);
      if (!variant) return;
      const size = this.bundleSizes().find((s) => normalizeTitle(s.variant_title) === normalizeTitle(variant.title));
      const row = size && this.el.bundleSizes && this.el.bundleSizes.querySelector(`input[value="${size.variant_title}"]`);
      // En størrelse uden nok på lager til en pakke skifter kun dette kort.
      if (!size || !row || row.disabled || size.variant_title === this.selectedSize()) {
        this.refreshDesktopButton(card);
        return;
      }
      this.setSize(size.variant_title);
      this.track('bundle_size_select', { size: size.variant_title, source: 'card' });
    }

    /**
     * Pakken i én størrelse: de resultater, der er på lager i størrelsen, og
     * prisen efter butikkens mængderabat for det antal.
     */
    bundleFor(size) {
      const lines = [];
      const missing = [];
      (this.state.results || []).forEach((result) => {
        const variant = this.variantFor(result, size.variant_title);
        if (variant && variant.available) lines.push({ result, variant });
        else missing.push(result);
      });
      const normal = lines.reduce((sum, line) => sum + line.variant.price, 0);
      const pct = discountFor(size.tiers, lines.length);
      const price = normal * (1 - pct / 100);
      return { size, lines, missing, normal, price, savings: normal - price, pct };
    }

    currentBundle() {
      const size = this.sizeConfig(this.selectedSize());
      return size ? this.bundleFor(size) : null;
    }

    /** 3 ml kan kun købes samlet: alle fire som prøver. */
    sampleBundle() {
      const size = this.bundleSizes().find((s) => normalizeTitle(s.variant_title) === this.sampleTitle);
      return size ? this.bundleFor(size) : null;
    }

    /** Kaldes ved visning, når lagerstatus ændrer sig, og ved skift mellem mobil og desktop. */
    renderBundle() {
      this.renderSizeToggle();
      this.updateCards();
      this.updateBundle();
      this.renderBundleRows();
    }

    /** Desktop: prøver, 4 × 30 ml og 4 × 100 ml med normalpris, pakkepris og besparelse. */
    renderBundleRows() {
      const fieldset = this.el.bundleSizes;
      if (!fieldset) return;
      const legend = fieldset.querySelector('legend');
      const total = (this.state.results || []).length;
      const selected = this.selectedSize();
      fieldset.replaceChildren(
        legend,
        ...this.bundleSizes().map((size) => this.renderBundleRow(this.bundleFor(size), size.variant_title === selected, total))
      );
    }

    renderBundleRow(bundle, checked, total) {
      const usable = bundle.lines.length >= 2;
      const count = usable ? bundle.lines.length : total;
      const size = sizeLabel(bundle.size.variant_title);
      const sample = normalizeTitle(bundle.size.variant_title) === this.sampleTitle;

      const label = document.createElement('label');
      label.className = 'pq-bundle__size';
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = `pq-bundle-${this.uid}`;
      input.value = bundle.size.variant_title;
      input.checked = checked;
      input.disabled = !usable;

      const body = document.createElement('span');
      body.className = 'pq-bundle__size-body';
      const name = document.createElement('span');
      name.className = 'pq-bundle__size-name';
      name.textContent = this.t(sample ? 'bundle_row_samples' : 'bundle_name', { count, size });
      const price = document.createElement('span');
      price.className = 'pq-bundle__size-price';
      const save = document.createElement('span');
      save.className = 'pq-bundle__size-save';

      if (usable) {
        if (bundle.savings >= 1) {
          const before = document.createElement('s');
          before.textContent = this.formatKr(bundle.normal);
          price.append(before, ' ');
        }
        const now = document.createElement('strong');
        now.textContent = this.formatKr(bundle.price);
        price.append(now);
        save.textContent =
          bundle.savings >= 1 ? this.t('bundle_save', { amount: this.formatKr(bundle.savings), pct: Math.round(bundle.pct) }) : '';
      } else {
        save.textContent = this.t('bundle_not_enough', { size });
      }

      body.append(name, price, save);
      label.append(input, body);
      return label;
    }

    updateBundle() {
      const results = this.state.results || [];
      const bundle = this.currentBundle();
      if (!this.el.bundle || results.length < 2 || !bundle || !this.marketDataReady) {
        this.setBundleVisible(false);
        return;
      }

      const total = results.length;
      const count = bundle.lines.length;
      const size = sizeLabel(bundle.size.variant_title);
      const usable = count >= 2;

      this.el.bundleTitle.textContent = this.t('bundle_title', { count: total });
      this.renderBundlePrice(bundle, size);
      this.renderBundleItems(bundle, size);

      this.el.bundleMissing.hidden = !bundle.missing.length || !usable;
      this.el.bundleMissing.textContent = this.t('bundle_missing', { count, size });

      const what = this.t(count === total ? 'bundle_add_all' : 'bundle_add_some', { count });
      this.el.bundleButtons.forEach((button) => {
        if (button.getAttribute('aria-busy') === 'true') return;
        button.textContent = !usable
          ? this.t('bundle_not_enough', { size })
          : bundle.savings >= 1
            ? this.t('bundle_add_save', { what, amount: this.formatKr(bundle.savings) })
            : what;
        button.disabled = !usable;
      });

      this.updateSamplesLink(total);
      if (this.el.bundleNote) {
        const threshold = this.freeShippingThreshold();
        const fragt = threshold ? ` ${this.t('free_shipping', { amount: this.formatKr(threshold) })}` : '';
        this.el.bundleNote.textContent = `${this.t('bundle_note')}${fragt}`;
      }
      this.setBundleVisible(true);
    }

    /** "4 × 100 ml  1.196 kr.  799 kr.  Spar 397 kr. (33 %)" */
    renderBundlePrice(bundle, size) {
      const el = this.el.bundlePrice;
      if (!el) return;
      if (bundle.lines.length < 2) {
        el.textContent = this.t('bundle_not_enough_long', { size });
        return;
      }
      const name = document.createElement('span');
      name.className = 'pq-bundle__price-name';
      name.textContent = this.t('bundle_name', { count: bundle.lines.length, size });
      const amount = document.createElement('span');
      amount.className = 'pq-bundle__price-amount';
      if (bundle.savings >= 1) {
        const before = document.createElement('s');
        before.textContent = this.formatKr(bundle.normal);
        amount.append(before, ' ');
      }
      const now = document.createElement('strong');
      now.textContent = this.formatKr(bundle.price);
      amount.append(now);
      const save = document.createElement('span');
      save.className = 'pq-bundle__price-save';
      save.textContent =
        bundle.savings >= 1 ? this.t('bundle_save', { amount: this.formatKr(bundle.savings), pct: Math.round(bundle.pct) }) : '';
      el.replaceChildren(name, amount, save);
    }

    /** "Eller prøv alle 4 som 3 ml-prøver for 129 kr." */
    updateSamplesLink(total) {
      const link = this.el.samplesButton;
      if (!link) return;
      const samples = this.sampleBundle();
      if (!samples || samples.lines.length < 2) {
        link.hidden = true;
        return;
      }
      if (link.getAttribute('aria-busy') === 'true') return;
      const n = samples.lines.length;
      const who = this.t(n === total ? 'samples_all' : 'samples_some', { count: n });
      link.textContent = this.t('samples_link', {
        who,
        size: sizeLabel(samples.size.variant_title),
        price: this.formatKr(samples.price),
      });
      link.hidden = false;
    }

    /**
     * Oversigt over duftene i pakken: "100 ml · H299 Inspireret af Ombre Nomade ·
     * <s>299 kr.</s> 199,75 kr.", hvor stykprisen er pakkeprisen delt med antallet
     * af dufte i pakken. Udsolgte dufte står gennemstreget.
     */
    renderBundleItems(bundle, size) {
      if (!this.el.bundleItems) return;
      this.el.bundleItems.replaceChildren(
        ...(this.state.results || []).map((result) => {
          const line = bundle.lines.find((l) => l.result === result);
          const item = document.createElement('li');
          item.className = `pq-bundle__item${line ? '' : ' pq-bundle__item--missing'}`;

          const thumb = document.createElement('img');
          thumb.className = 'pq-bundle__thumb';
          thumb.alt = '';
          thumb.width = 32;
          thumb.height = 32;
          thumb.loading = 'lazy';
          if (result.image_url) thumb.src = sizedImage(result.image_url, 64);

          const text = document.createElement('span');
          text.className = 'pq-bundle__item-text';
          if (line) {
            // Prisdelen indsættes som elementer, så normalprisen kan streges over.
            const marker = '\u0000';
            let [before, after = ''] = this.t('item_line', { size, name: fullName(result.title), price: marker }).split(marker);
            // Skilletegnet før prisen følger prisen, og prisen følger navnets sidste
            // ord, så en ombrudt linje aldrig starter med "·" eller en løs pris.
            const sep = before.match(/\s*[·•|–-]\s*$/);
            const price = this.bundleItemPrice(line.variant.price, bundle);
            if (sep) {
              before = before.slice(0, -sep[0].length);
              price.prepend(`\u00a0${sep[0].trim()} `);
            }
            text.append(before, price, after);
          } else {
            text.textContent = this.t('item_missing', { code: productCode(result.title), size });
          }
          text.title = result.title || '';

          item.append(thumb, text);
          return item;
        })
      );
    }

    /**
     * Normalpris gennemstreget og stykprisen i pakken; uden rabat kun prisen.
     * Stykprisen er den viste pakkepris delt med antallet af dufte, med to
     * decimaler (199,75 kr.) og uden decimaler, når den går op (200 kr.).
     * Alt regnes ud fra variantpriserne og mængderabatterne i quiz_config.
     */
    bundleItemPrice(normalPrice, bundle) {
      const price = document.createElement('span');
      price.className = 'pq-bundle__item-price';
      const whole = WHOLE_UNIT_CURRENCIES.includes(this.currency);
      const shownTotal = whole ? Math.round(bundle.price) : Math.round(bundle.price * 100) / 100;
      const perItem = Math.round((shownTotal / bundle.lines.length) * 100) / 100;
      const discounted = bundle.savings >= 1 && normalPrice - perItem >= 0.01;
      if (discounted) {
        const before = document.createElement('s');
        before.textContent = this.formatKr(normalPrice);
        price.append(before, ' ');
      }
      const now = document.createElement('span');
      now.className = 'pq-bundle__item-now';
      now.textContent = discounted ? this.formatPrice(perItem) : this.formatKr(normalPrice);
      price.append(now);
      return price;
    }

    setBundleVisible(visible) {
      if (this.el.bundle) this.el.bundle.hidden = !visible;
      if (this.el.stickyBar) this.el.stickyBar.hidden = !visible;
    }

    /** Lægger pakken (eller prøverne) i kurven i ét kald. */
    async addBundle(button, bundle = this.currentBundle()) {
      if (!bundle || bundle.lines.length < 2) return;
      const samples = normalizeTitle(bundle.size.variant_title) === this.sampleTitle;

      this.setBusy(button, true);
      try {
        await this.cartAdd(bundle.lines.map((line) => line.variant.id), null);
        this.track('add_bundle', {
          size: bundle.size.variant_title,
          count: bundle.lines.length,
          product_ids: bundle.lines.map((line) => line.result.product_id),
          variant_ids: bundle.lines.map((line) => line.variant.id),
          price: Math.round(bundle.price * 100) / 100,
          savings: Math.round(bundle.savings * 100) / 100,
          source: samples ? 'samples' : 'bundle',
        });
        const what = samples
          ? this.t('status_samples_added', { count: bundle.lines.length })
          : this.t('status_bundle_added');
        this.setCartStatus(
          bundle.savings >= 1 ? this.t('status_discount', { what, amount: this.formatKr(bundle.savings) }) : what
        );
        this.setBusy(button, false);
        this.flashAdded(button);
      } catch (error) {
        this.setBusy(button, false);
        if (error.status === 422) {
          // En af varianterne er blevet udsolgt siden resultatet blev beregnet.
          await this.refreshAvailability();
          this.setCartStatus(this.t('status_bundle_changed'), true);
        } else {
          this.setCartStatus(this.t('status_bundle_error'), true);
        }
      }
    }

    /**
     * Titler, priser og lagerstatus fra butikken (/products/<handle>.js). Shopify
     * svarer med markedets oversatte titel og priser i markedets valuta, så intet
     * omregnes af os. Fejler et opslag i et andet marked end DK, vises ingen priser.
     */
    async loadMarketData() {
      const results = this.state.results || [];
      const svar = await Promise.all(
        results.map(async (result) => {
          if (!result.handle) return false;
          try {
            const product = await this.cartRequest(`products/${result.handle}.js`);
            if (product.title) result.title = product.title;
            (result.variants || []).forEach((variant) => {
              const fresh = (product.variants || []).find((v) => v.id === variant.id);
              if (fresh) {
                variant.price = fresh.price / 100;
                variant.available = Boolean(fresh.available);
              }
            });
            return true;
          } catch (error) {
            return false;
          }
        })
      );
      this.marketDataReady = this.currency === 'DKK' || svar.every(Boolean);
      this.save();
    }

    /** Henter aktuel lagerstatus fra Shopify og tegner kort og pakke igen. */
    async refreshAvailability() {
      await this.loadMarketData();
      this.renderCards();
      this.renderBundle();
    }

    /** Beløb afrundet som butikken viser dem: hele kroner i DKK og SEK, cent i EUR. */
    /**
     * Grænsen for fri fragt i markedets valuta: fra dashboardet (/config), når
     * den er sat der, ellers temaets indstilling. null i dashboardet = ingen tekst.
     */
    freeShippingThreshold() {
      const fromConfig = this.config && this.config.free_shipping;
      if (fromConfig && Object.prototype.hasOwnProperty.call(fromConfig, this.currency)) {
        return Number(fromConfig[this.currency]) || 0;
      }
      return this.freeShipping;
    }

    formatKr(amount) {
      const whole = WHOLE_UNIT_CURRENCIES.includes(this.currency);
      return this.formatPrice(whole ? Math.round(amount) : Math.round(amount * 100) / 100);
    }

    /**
     * Lægger varianter i kurven med quiz-sessionen på både linjerne og kurven,
     * så backenden kan koble ordren til quizzen.
     */
    async cartAdd(variantIds, productId) {
      const sessionId = this.state.session_id;
      const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map(
        (element) => element.dataset.sectionId
      );

      const body = {
        items: variantIds.map((id) => ({ id, quantity: 1, properties: { _quiz_session: sessionId } })),
        attributes: { quiz_session: sessionId },
      };
      if (sectionIds.length) {
        body.sections = sectionIds.join(',');
        body.sections_url = window.location.pathname;
      }

      const added = await this.cartRequest('cart/add.js', body);

      // /cart/add.js dokumenterer ikke attributes, så kurvattributten
      // sikres med et ekstra kald, hvis den ikke kom med. Varerne er allerede
      // i kurven her, så en fejl i dette trin må ikke meldes som fejl.
      try {
        let cart = await this.cartRequest('cart.js');
        if (!cart.attributes || cart.attributes.quiz_session !== sessionId) {
          cart = await this.cartRequest('cart/update.js', { attributes: { quiz_session: sessionId } });
        }
        this.notifyTheme(cart, added.sections, productId);
      } catch (error) {
        // Linjeegenskaben _quiz_session er stadig sat, så ordren kan kobles.
      }
    }

    async cartRequest(path, body) {
      const response = await fetch(this.url(path), {
        method: body ? 'POST' : 'GET',
        headers: body
          ? { 'Content-Type': 'application/json', Accept: 'application/json' }
          : { Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined,
        credentials: 'same-origin',
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new ApiError(data.description || data.message || 'cart_error', response.status);
      return data;
    }

    /**
     * Horizon-temaet lytter efter "cart:update": kurvikonet sætter antallet,
     * kurvlinjerne gentegnes, og drawer'en åbner sig selv, hvis den har
     * auto-open. Ellers åbnes den her.
     */
    notifyTheme(cart, sections, productId) {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: 'purabelle-quiz',
            data: {
              source: 'purabelle-quiz',
              itemCount: cart.item_count,
              productId: productId ? String(productId) : undefined,
              sections,
            },
          },
        })
      );

      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && !drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') {
        drawer.open();
      }
    }

    /** Husker at en variant er udsolgt og tegner kort og pakke igen. */
    markSoldOut(variantId) {
      (this.state.results || []).forEach((result) => {
        const variant = (result.variants || []).find((v) => v.id === variantId);
        if (variant) variant.available = false;
      });
      this.save();
      this.renderBundle();
    }

    flashAdded(button) {
      const original = button.textContent;
      const added = this.t('added');
      button.textContent = added;
      window.setTimeout(() => {
        if (button.textContent === added) button.textContent = original;
      }, 2000);
    }

    setCartStatus(message, isError = false) {
      this.el.cartStatus.textContent = message;
      this.el.cartStatus.classList.toggle('pq-is-error', isError);
    }

    /* ----- Tracking ----- */

    /** Siden forlades: send abandon, hvis quizzen er påbegyndt men ikke gennemført. */
    onLeave() {
      if (this.state && this.state.session_id && !this.state.completed && !this.abandonSent) {
        const question = this.question;
        this.track('abandon', {
          reason: 'page_leave',
          step: this.state.step + 1,
          question: question ? question.id : null,
        });
        this.abandonSent = true;
      }
      this.tracker.flushOnExit();
    }

    /* ----- E-mail ----- */

    resetEmailBox() {
      const form = this.el.emailForm;
      if (!form) return;
      // E-mailen hører til sessionen, så den skjules på et delt resultat.
      form.hidden = !(this.state.results || []).length || Boolean(this.state.shared);
      if (this.state.email_sent) {
        this.showEmailSent(this.state.email_sent);
        return;
      }
      form.reset();
      form.classList.remove('pq-is-sent');
      form.email.removeAttribute('aria-invalid');
      this.el.emailFields.hidden = false;
      this.setEmailStatus('');
    }

    async submitEmail(event) {
      event.preventDefault();
      const form = this.el.emailForm;
      const input = form.email;
      const button = form.querySelector('[type="submit"]');
      const email = input.value.trim();
      const consent = form.marketing_consent.checked;

      if (!EMAIL_PATTERN.test(email)) {
        input.setAttribute('aria-invalid', 'true');
        this.setEmailStatus(this.t('email_invalid'), true);
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');

      this.setBusy(button, true);
      this.setEmailStatus('');
      try {
        await api('/email', {
          method: 'POST',
          body: { session_id: this.state.session_id, email, marketing_consent: consent },
        });
        this.state.email_sent = email;
        this.save();
        this.showEmailSent(email);
      } catch (error) {
        const message =
          error.status === 400 && error.message === 'Ugyldig e-mail'
            ? this.t('email_rejected')
            : this.t('email_error');
        this.setEmailStatus(message, true);
      } finally {
        this.setBusy(button, false);
      }
    }

    showEmailSent(email) {
      this.el.emailFields.hidden = true;
      this.el.emailForm.classList.add('pq-is-sent');
      this.setEmailStatus(this.t('email_sent', { email }));
    }

    setEmailStatus(message, isError = false) {
      this.el.emailStatus.textContent = message;
      this.el.emailStatus.classList.toggle('pq-is-error', isError);
    }

    /* ----- Fejl ----- */

    showError(message, retryAction) {
      this.el.errorText.textContent = message;
      this.retryAction = retryAction;
      this.show('error');
      this.focus(this.el.errorTitle);
    }

    /* ----- Visning ----- */

    show(name) {
      this.screen = name;
      this.el.screens.forEach((screen) => {
        screen.hidden = screen.dataset.screen !== name;
      });
    }

    focus(element) {
      if (!element) return;
      element.focus({ preventScroll: true });
      // På mobil kan sektionens top være rullet ud af syne ved skærmskift.
      const top = this.root.getBoundingClientRect().top;
      if (top < 0) this.root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    setBusy(button, busy) {
      if (!button) return;
      button.disabled = busy;
      button.setAttribute('aria-busy', String(busy));
    }

    setNotice(message) {
      if (!this.el.notice) return;
      this.el.notice.textContent = message;
      this.el.notice.hidden = !message;
    }

    setSessionParam(sessionId) {
      const url = new URL(window.location.href);
      if (url.searchParams.get('session') === sessionId) return;
      url.searchParams.set('session', sessionId);
      window.history.replaceState(window.history.state, '', url);
    }

    removeSessionParam() {
      this.removeParam('session');
    }

    removeParam(name) {
      const url = new URL(window.location.href);
      if (!url.searchParams.has(name)) return;
      url.searchParams.delete(name);
      window.history.replaceState(window.history.state, '', url);
    }
  }

  function boot() {
    document.querySelectorAll('[data-pq][data-mode="full"]').forEach((root) => {
      if (root.dataset.pqReady) return;
      root.dataset.pqReady = 'true';
      new Quiz(root).init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Temaeditoren genindlæser sektioner uden at genindlæse siden.
  document.addEventListener('shopify:section:load', boot);
})();
